import api from "./axios";

export const getBranchUsers = async (branchId) => {
    const res = await api.get(`/branch_user_list/${branchId}`);

    return Array.isArray(res.data?.branch_users)
        ? res.data.branch_users
        : [];
};
